import {
    CREATE_ARCHITECTURESERVER,
    CREATEFRANCHISE_ARCHITECTURESERVER,
    RETRIEVE_ARCHITECTURESERVER,
    RETRIEVESINGLE_ARCHITECTURESERVER,
    UPDATE_ARCHITECTURESERVER,
    DELETE_ARCHITECTURESERVER,
  } from "../actions/type";
  const initialState = [];
  function ARCServersReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case CREATE_ARCHITECTURESERVER:
        return {data: state.data, payload};
      case CREATEFRANCHISE_ARCHITECTURESERVER:
        return {data: state.data, payload};
      case RETRIEVE_ARCHITECTURESERVER:
        state = (payload.error == 1)?initialState:payload;
        return {data: state, payload};
      case RETRIEVESINGLE_ARCHITECTURESERVER:
        state = (payload.error == 1)?initialState:payload;
        return {data: state.data, payload};
      case UPDATE_ARCHITECTURESERVER:
        return {data: state.data, payload};
      case DELETE_ARCHITECTURESERVER:
        return {data: state.data, payload};
      default:
        return state;
    }
  };
  export {ARCServersReducer};